import { render, staticRenderFns } from "./DiscountSwitcher.vue?vue&type=template&id=2b0d630e&"
import script from "./DiscountSwitcher.vue?vue&type=script&lang=js&"
export * from "./DiscountSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSwitcher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports